import { wsService } from "./wsService";

const section = "canales_ventas";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

export const canalesVentasService = {
  section,
  filter,
};
